<template>
  <div class="ts-panel" :class="{ small: size === 'small' }">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.ts-panel {
  border-radius: 24px;
  box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
  border: solid 2px rgba(255, 255, 255, 0.32);
  background-blend-mode: soft-light, normal;
  background-image: linear-gradient(324deg, #000000 100%, var(--fills-neutral-white) -6%),
    linear-gradient(to bottom, #ebecf0, #ebecf0);

  &.small {
    border-radius: 16px;
  }
}
</style>

<script>
export default {
  name: 'TsPanel',
  props: {
    size: {
      type: String,
      default: 'medium'
    }
  }
};
</script>
